import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'
import { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { CFDROUTE } from 'pages/CustomerFacingDisplayPage/CFDLayout'
import usePOSRequestCaller from './usePosRequestCaller'
import { COOKIES_TOKEN } from 'views/CustomerFacingDisplay/utils/localStorageKey'
import cookies from 'utilities/cookie'

const useValidateConnection = (isReady: boolean) => {
    const history = useHistory()
    const { get } = usePOSRequestCaller()
    const isTokenValid = useCallback(async () => {
        try {
            const token = cookies.get(COOKIES_TOKEN)
            if (!token) return false

            await get(`/auth/check-non-client-token`, {
                showSuccessToast: false,
            })
            return true
        } catch (error) {
            return false
        }
    }, [get])

    const {
        clientID,
        onConnectToPOS,
        hwAgentUrl,
        isManualConnect,
    } = useCFDContext()

    useEffect(() => {
        if (!isReady) return

        if (!hwAgentUrl) history.replace(CFDROUTE.HW_SETTING)
        else if (clientID) {
            onConnectToPOS()
        } else {
            history.replace(CFDROUTE.CONNECT_CODE)
        }
    }, [
        clientID,
        history,
        hwAgentUrl,
        isManualConnect,
        isReady,
        onConnectToPOS,
    ])
    return { isTokenValid }
}
export default useValidateConnection
